import React from "react";
import type { ThreadEvent } from "@/domain/threadEvent";
import { LetterMessage } from "@/components/messages/renderers/LetterMessage";
import { PostcardMessage } from "@/components/messages/renderers/PostcardMessage";
import { EMessage } from "@/components/messages/renderers/EMessage";

export function PmMessageContent({ event }: { event: ThreadEvent }) {
  const render = (() => {
    switch (event.kind) {
      case "letter":
        return <LetterMessage event={event} />;
      case "postcard":
        return <PostcardMessage event={event} />;
      case "emessage":
        return <EMessage event={event} />;
      default: {
        const _exhaustive: never = event.kind;
        return _exhaustive;
      }
    }
  })();

  return <div className="ph-no-capture">{render}</div>;
}
